import { Link } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader.jsx';
import Footer from '../components/Footer.jsx';
import { useTitle } from '../lib/useTitle.js';
import { useMetaTags } from '../lib/useMetaTags.js';
import { ARTICLES } from '../content/learn/_articles.js';

export default function Learn() {
  useTitle('Learn');
  useMetaTags({
    description: 'Short, honest articles on calories, recomp, deload weeks, and reading the scale. The science TrainForge applies in your program automatically.',
    ogTitle: 'TrainForge Learn | fitness articles without the fluff',
    ogDescription: 'How calorie targets work, why recomp is hard, what deload weeks do, and how to read the scale honestly.',
    ogType: 'website',
    canonical: 'https://mytrainforge.com/learn',
  });

  return (
    <div>
      <PublicHeader />
      <div className="shell" style={{ maxWidth: 720 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontSize: '2.2rem', margin: 0 }}>Learn</h1>
          <p style={{ color: 'var(--text-dim)', marginTop: 8 }}>
            Short, honest articles on the science TrainForge applies in your program. Written by lifters, for lifters.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`/learn/${a.slug}`}
              style={{
                display: 'block',
                background: 'var(--bg-elev)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-lg)',
                padding: 20,
                textDecoration: 'none',
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>{a.title}</div>
              <div style={{ fontSize: 14, color: 'var(--text-dim)', lineHeight: 1.5 }}>{a.summary}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 10 }}>{a.date}</div>
            </Link>
          ))}
        </div>

        <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 32, textAlign: 'center' }}>
          More articles coming. Have a question you'd like covered? <Link to="/contact" style={{ color: 'var(--accent)' }}>Let us know</Link>.
        </p>
      </div>
      <Footer />
    </div>
  );
}
